import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Sidebar from './components/sidebar';
import { useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios';

const Cirpacademy = () => {
  const navigate = useNavigate();
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCursos = async () => {
      try {
        const response = await axios.get('https://api.mrcirp.com/public/cursos');
        setCursos(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCursos();
  }, []);

  const handleCardClick = (cursoId) => {
    navigate(`/modulo/${cursoId}`);
  };

  if (loading) {
    return (
      <Sidebar>
        <div className="container mt-4">
          <div className="text-center">Cargando cursos...</div>
        </div>
      </Sidebar>
    );
  }

  if (error) {
    return (
      <Sidebar>
        <div className="container mt-4">
          <div className="alert alert-danger">Error al cargar los cursos: {error}</div>
        </div>
      </Sidebar>
    );
  }

  return (
    <div>
      <Sidebar>
        <div className="container mt-4">
          <Row>
            {cursos.map((curso) => (
              <Col key={curso.id} md={4} className="mb-4">
                <Card 
                  onClick={() => handleCardClick(curso.id)}
                  style={{ cursor: 'pointer' }}
                  className="h-100"
                >
                  <Card.Img 
                    variant="top" 
                    src={curso.imagen || "https://via.placeholder.com/300x200?text=Sin+imagen"} 
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <Card.Body>
                    <Card.Title>{curso.nombrecurso || 'Curso sin título'}</Card.Title>
                    <Card.Text>
                      {curso.descripcion || 'Descripción no disponible'}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Sidebar>
    </div>
  );
};

export default Cirpacademy;